import { useQuery } from 'react-query';
import axios from 'axios';
import { ONBOARDING_PUB } from '../utils/constants';

export const useCountries = (): any => (useQuery<Record<string, any>, Error>('countries', async () => {
  const { data } = await axios.get<any>(`${ONBOARDING_PUB}/countries/`);
  const response = data?.data;
  return response;
})
);